import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './pages/Login/LoginReducer';

export const store = configureStore({
  reducer: {
    login: loginReducer,
  },
});

export default store;
